import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useApi } from '../api/contexto'
import type { PaginaClientes } from '../api/modelos'
import { CLASE_INPUT } from './formulario'

/**
 * Elegir un cliente por nombre o móvil (filtro de Albaranes). Busca a partir
 * de dos letras y devuelve el id; «Todos» lo quita.
 */
export function SelectorCliente({
  valor,
  onCambiar,
}: {
  valor: { id: string; nombre: string } | null
  onCambiar: (cliente: { id: string; nombre: string } | null) => void
}) {
  const api = useApi()
  const [q, setQ] = useState('')
  const busqueda = useQuery({
    queryKey: ['clientes', 'selector', q],
    queryFn: ({ signal }) => api.pedir<PaginaClientes>('/api/clientes', { parametros: { q, page_size: 8 }, senal: signal }),
    enabled: q.trim().length >= 2,
  })

  if (valor) {
    return (
      <div className="flex items-center gap-2">
        <span className="truncate rounded-full bg-acento-suave px-3 py-1 text-sm font-medium text-acento-tinta">{valor.nombre}</span>
        <button type="button" onClick={() => onCambiar(null)} className="text-xs font-medium text-tinta-2 underline">
          Todos los clientes
        </button>
      </div>
    )
  }

  return (
    <div className="relative">
      <input
        type="search"
        aria-label="Cliente"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Todos (escribe para buscar)"
        className={CLASE_INPUT}
      />
      {q.trim().length >= 2 && busqueda.data ? (
        <ul aria-label="Clientes encontrados" className="absolute z-20 mt-1 max-h-60 w-full overflow-y-auto rounded-lg border border-borde bg-superficie">
          {busqueda.data.items.length === 0 ? (
            <li className="px-3 py-2 text-sm text-tinta-apagada">Sin resultados</li>
          ) : (
            busqueda.data.items.map((c) => (
              <li key={c.id}>
                <button
                  type="button"
                  className="w-full px-3 py-2 text-left text-sm text-tinta hover:bg-elevado"
                  onClick={() => {
                    onCambiar({ id: c.id, nombre: c.nombre })
                    setQ('')
                  }}
                >
                  {c.nombre}
                </button>
              </li>
            ))
          )}
        </ul>
      ) : null}
    </div>
  )
}
